<template>
  <div
    class="tei-response-bar"
    :class="{
      [`tei-response-bar--${state}`]: true,
      'tei-response-bar--centered': centerText,
    }"
    :role="alertEnabled ? 'alert' : undefined"
  >
    <div
      class="tei-response-bar--content"
      v-html="formattedContent"
    />
    <div
      v-if="!userIsStudent && !studentView && !canTryAgain"
      class="tei-response-bar--actions"
    >
      <TEIStartOverButton />
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import TEIStartOverButton from '@/components/teis/TEIStartOverButton.vue';
import {
  useEditorStore,
  useUserStore,
} from '@/stores';

export default {
  components: {
    TEIStartOverButton,
  },
  props: {
    state: {
      type: String,
      default: 'correct', // correct, incorrect
    },
    content: {
      type: String,
      default: null,
    },
    centered: {
      type: Boolean,
      default: true,
    },
    alertEnabled: {
      type: Boolean,
      default: false,
    },
    canTryAgain: {
      type: Boolean,
      default: false,
    },
    correctPrependMessage: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapState(useEditorStore, [
      'studentView',
    ]),
    ...mapState(useUserStore, [
      'userIsStudent',
    ]),
    centerText() {
      if (this.userIsStudent === false) {
        return false;
      }
      return this.centered;
    },
    formattedContent() {
      // Feedback is usually formatted in a div, but it gets prepended with
      // generic messages as well.

      if (this.state !== 'correct' && !this.canTryAgain) {
        // If we have an incorrect feedback but no tries are remaining,
        // return the content as it is, with no prepended message
        return this.content;
      }

      const feedbackMessage = document.createElement('b');
      feedbackMessage.append(this.state === 'correct'
        ? (this.correctPrependMessage || this.$t('That is right!'))
        : this.$t('Try again!'));

      const wrapper = document.createElement('div');
      wrapper.innerHTML = this.content;

      (wrapper.firstElementChild || wrapper).prepend(feedbackMessage, ' ');

      return wrapper.innerHTML;
    },
  },
};
</script>

<style lang="stylus">
.tei-response-bar {
  padding: $nebula-space-2x $nebula-space-4x;
  padding-inline-end: 350px;
  width: 100%;
  z-index: 1;
  display: flex;

  &--correct {
    background-color: var(--tei-response-correct-color);
    color: var(--tei-response-correct-font-color);
  }

  &--incorrect {
    background-color: var(--tei-response-incorrect-color);
    color: var(--tei-response-incorrect-font-color);
  }

  &--centered {
    padding-inline-end: $nebula-space-3x;
    text-align: center;
  }

  &--content {
    width:100%;
  }

  &--actions {
    align-items: center;
    bottom: $nebula-space-2x;
    display: flex;
    gap: $nebula-space-1x;
    inset-inline-end: $nebula-space-3x;
    justify-content: center;
    position: absolute;
    z-index: 1;
  }
}
</style>
